import { API_BASE_URL } from './config';
import { escapeHtml, isValidUrl, apiFetch, markLoaded, renderError } from './helpers';
import type { FactOfTheDayResponse } from './types';

/** Finnish calendar day as YYYY-MM-DD, used to bust any edge cache the moment the day rolls over. */
function finnishDateKey(): string {
    const finnishNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Helsinki' }));
    const month = String(finnishNow.getMonth() + 1).padStart(2, '0');
    const day = String(finnishNow.getDate()).padStart(2, '0');
    return `${finnishNow.getFullYear()}-${month}-${day}`;
}

export async function fetchOnThisDay(): Promise<void> {
    const container = document.getElementById('history-events');
    if (!container) return;

    try {
        const response = await apiFetch(`${API_BASE_URL}/onthisday?date=${finnishDateKey()}`);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const data: FactOfTheDayResponse = await response.json();

        if (!data.fact) {
            container.innerHTML = '<p class="history-error">No historical fact available.</p>';
            return;
        }

        const fact = data.fact;
        const summaryHtml = fact.summary
            ? `<div class="history-summary">${escapeHtml(fact.summary)}</div>`
            : '';
        let linkUrl = fact.articleUrl || '';
        if (linkUrl && fact.text) {
            const fragment = encodeURIComponent(fact.text.substring(0, 100));
            linkUrl += `#:~:text=${fragment}`;
        }

        const titleHtml = linkUrl && isValidUrl(fact.articleUrl || '')
            ? `<a href="${escapeHtml(linkUrl)}" target="_blank" rel="noopener noreferrer">${escapeHtml(fact.text)}</a>`
            : escapeHtml(fact.text);

        const [mm, dd] = data.date.split('-').map(Number);
        const eventDate = new Date(fact.year, mm - 1, dd);
        const fullDate = eventDate.toLocaleDateString('fi-FI', { day: 'numeric', month: 'long', year: 'numeric' });

        container.innerHTML = `<div class="history-event">
            <div class="history-date-badge">${fullDate}</div>
            <div class="history-text">${titleHtml}</div>
            ${summaryHtml}
        </div>`;
        markLoaded(container, 'history');
    } catch (error) {
        renderError(container, 'history', 'Could not load historical fact.', error);
    }
}
